export default "__VITE_ASSET__cq7OMkgC__"